import { render, staticRenderFns } from "./EditStock.vue?vue&type=template&id=953dd870"
import script from "./EditStock.vue?vue&type=script&lang=js"
export * from "./EditStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports